import * as React from "react";
import Box from "@mui/material/Box";
import { Avatar, Drawer, IconButton, Tooltip, Typography } from "@mui/material";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import { info } from "../iconsImports";
import ApiEndpoints from "../network/ApiEndPoints";
import { postFormData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { useState } from "react";
import { Icon } from "@iconify/react";

const RejectPg = ({ row, refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);

  const handleReject = (event) => {
    event.preventDefault();
    postFormData(
      ApiEndpoints.REJECT_CUSTOMER, // You may want to change this endpoint to a proper REJECT one
      { id: row.id,status:0 },
      setRequest,
      (res) => {
        handleClose();
        okSuccessToast(res.data.message);
        if (refresh) {
          refresh();
        }
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "grid", justifyContent: "center" }}>
      <Tooltip title="Reject">
        <IconButton sx={{ color: "#ff0000" }} onClick={handleOpen}>
          <Icon icon="mdi:close-circle-outline" width={24} height={24} />
        </IconButton>
      </Tooltip>

      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400 }} className="sm_modal">
          <ModalHeader
            title="Reject Request"
            handleClose={handleClose}
            subtitle="Please confirm to reject the request"
          />

          <Box
            component="form"
            id="RejectPg"
            noValidate
            autoComplete="off"
            onSubmit={handleReject}
            className="text-center"
            sx={{
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              px: 3,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                src={info}
                sx={{
                  width: 160,
                  height: 160,
                  objectFit: "cover",
                  objectPosition: "100% 0",
                }}
                alt="info-icon"
              />
            </Box>

            <Typography variant="h6" sx={{ textAlign: "center" }}>
              Are you sure?
            </Typography>
            <Typography sx={{ mt: 2, textAlign: "center" }}>
              You want to reject this request?
            </Typography>
          </Box>

          <Box sx={{ mr: "10px" }}>
            <ModalFooter form="RejectPg" request={request} btn="YES" />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default RejectPg;
